import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
})
export class InstagramComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
